import Swiper from 'swiper';

export function initSwiper(container) {
    new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        loop: true,
        navigation: {
            nextEl: '.menu-button-next',
            prevEl: '.menu-button-prev',
        },
    })
}
